import ConnectionPool from './ConnectionPool';
import SocketConnection from './SocketConnection';
import { chatProtocol, endpoints as defaults, retryDelay } from './protocol';

// Composition for an independently owned client. Tests can substitute every IO boundary.
export default function createChatClient({ socketFactory, lifecycleFactory, scheduler, urlForPath,
  onListenerError, random, endpoints = defaults }) {
  return new ConnectionPool({ onListenerError, createConnection(kind, token) {
    const endpoint = endpoints[kind];
    if (!endpoint) throw new Error('Unknown chat audience');
    return new SocketConnection({
      socketFactory: () => socketFactory(urlForPath(endpoint.path)),
      lifecycle: lifecycleFactory(endpoint.pauseWhenHidden),
      scheduler, protocol: chatProtocol, token,
      retryDelay: attempt => retryDelay(attempt) + random() * 300,
    });
  } });
}
